<template>
  <div ref="root" />
</template>

<script>
export default {
  name: 'ProfileWidget',
  data() {
    return {
      instance: null
    }
  },
  computed: {
    userRoles() {
      return this.$page.props.roles || []
    },
    hasAccessAdmin() {
      if (!this.$page.props.user || !this.userRoles.length) {
        return false
      }

      return this.userRoles.some((role) =>
        ['admin', 'product_owner', 'moderator', 'create_draft'].includes(role)
      )
    },
    isQuickTestsModerator() {
      return this.userRoles.includes('quick_tests_moderator')
    },
    customProfileMenuItemsAll() {
      const sections = []

      if (this.hasAccessAdmin || this.isQuickTestsModerator) {
        const adminItems = []

        if (this.hasAccessAdmin) {
          adminItems.push({
            title: 'Панель администратора',
            endpoint: legacyUrl(),
            target: '_blank',
            imgLink: '/icons/administrator.svg',
          })
        }

        if (this.isQuickTestsModerator && this.$page.props.abilities.quick_tests_access) {
          adminItems.push({
            title: 'Модерация быстрых тестов',
            endpoint: '/tests/moderation',
            target: '_blank',
            imgLink: '/icons/admin-role.svg',
          })
        }

        if (adminItems.length) {
          sections.push({
            customItems: {
              title: 'Администрирование',
              items: adminItems,
            },
          })
        }
      }

      sections.push({
        customItems: {
          title: 'Поддержка',
          items: [
            {
              title: 'Справка',
              endpoint: 'https://support.mts.ru/betatesting',
              target: '_blank',
              imgLink: '/icons/info-circle.svg',
            },
            {
              title: 'Задать вопрос',
              endpoint: '/ask_question',
              target: '_self',
              imgLink: '/icons/question-circle.svg',
            },
            {
              title: 'Видеоинструкция',
              endpoint: '/videos',
              target: '_self',
              imgLink: '/icons/series.svg',
            },
          ],
        },
      })

      return sections
    },
  },
  async mounted() {
    await this.$nextTick()

    try {
      this.instance = new window.profileWidgetApp({
        target: this.$refs.root,
        props: {
          loginEndpoint: '/oauth/redirect',
          logoutEndpoint: '/logout',
          serviceManageEndpoint: '/profile',
          serviceManageLink: '/profile',
          serviceManageTitle: 'Личный кабинет',
          serviceManageImgLink: '/icons/administrator.svg',
          queryHideProductsButton: 768,
          customProfileMenuItemsAll: this.customProfileMenuItemsAll,
        },
      })
    } catch (e) {
      console.error('Не удалось инициализировать виджет профиля', e)
    }
  },
  destroyed() {
    if (this.instance) {
      this.instance.$destroy()
    }
  },
}
</script>

<style scoped></style>
